import {
  OBSERVADOR_INICIALITZAR,
  OBSERVADOR_INTRODUCCIO_OMPLIR_DADES,
  OBSERVADOR_INTRODUCCIO_MODIFICAR_CAMP,
  OBSERVADOR_INTRODUCCIO_DESCARTAR_CANVIS,
  OBTENIR_DADES_OBSERVADOR,
  ESBORRAR_OBSERVADOR_SELECCIONAT
} from "../../../actions/actionTypes";

export const OBSERVADOR_FORMULARI_DADES_EDITADES_ESTAT_INICIAL = {
  carrer: null,
  codiINE: null,
  codiPostal: null,
  nom: null,
  cognom1: null,
  cognom2: null,
  comarca: null,
  expert: null,
  municipi: null,
  numero: null,
  pis: null,
  porta: null,
  permisMostrarNom: null,
  telefon: null,
  usuariCorreuElectronic: null,
  usuariActiu: null,
  usuariNom: null,
  usuariRol: null,
  dataAlta: null,
  dataBaixa: null,
  foto: null
};

const editades = (
  state = OBSERVADOR_FORMULARI_DADES_EDITADES_ESTAT_INICIAL,
  action
) => {
  switch (action.type) {
    case OBSERVADOR_INICIALITZAR:
    case OBSERVADOR_INTRODUCCIO_DESCARTAR_CANVIS:
    case `${OBTENIR_DADES_OBSERVADOR}_EN_CURS`:
    case `${OBTENIR_DADES_OBSERVADOR}_ERROR`:
    case ESBORRAR_OBSERVADOR_SELECCIONAT:
      return OBSERVADOR_FORMULARI_DADES_EDITADES_ESTAT_INICIAL;

    case OBSERVADOR_INTRODUCCIO_OMPLIR_DADES:
      return action.dades;

    case OBSERVADOR_INTRODUCCIO_MODIFICAR_CAMP: {
      const { idCamp, valor } = action;
      return { ...state, [idCamp]: valor };
    }
    case `${OBTENIR_DADES_OBSERVADOR}_SUCCESS`: {
      return action.payload[action.payload[Object.keys(action.payload)[0]].key];
    }

    default:
      return state;
  }
};

export default editades;
